import React from 'react'
import OrderDetailScreen from '../Components/UserPanel/OrderDetailScreen'

const OrderDetail = () => {
    return (
        <>
            <OrderDetailScreen />
        </>
    )
}

export default OrderDetail